
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goodfynd-sites/[[...params]]",
      function () {
        return require("private-next-pages/goodfynd-sites/[[...params]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goodfynd-sites/[[...params]]"])
      });
    }
  